import { httpUtil } from './httpUtil'
import { ErrorCodes, createResult, createCommonResult } from './resultUtil'
import { account } from './account';
import { getOrderConfig, getPortalConfigV2 } from '../../utils/common';

export const orders = {
	getMyOrders,
	getOrder,
	getProductCategories,
	getProducts,
	getProductVariations,
	getProductComponents,
	orderProvisioning,
	orderFulfillment,
	estimateOrder,
	makeOrder,
	getProductDetail,
	getOrderCatalogs,
	getOrderCategories,
	createPaymentForm,
	getPriceTerms,
	getQueues
}

async function getMyOrders({
	page = 1,
	size = 20,
	sort,//='UPDATED_DATE',
	order, //='DESC'
} = {},) {
	try {
		let id = httpUtil.getSession().sub;
		//console.log('API: ', contact)
		let response = await httpUtil.get({
			resourcePath: '/v1/contacts/' + id + '/orders',
			queryParams: {
				page,
				size,
				sort,
				order
			},
			withAccessToken: true
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception getMyOrders: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getOrder(id) {
	try {
		//console.log('API: ', contact)
		let response = await httpUtil.get({
			resourcePath: '/v1/orders/' + id,
			withAccessToken: true
		});
		//check return code here instead of put as there would be different intepretation for different API
		if (response.code == "OK")
			return createResult(ErrorCodes.OK, response.data);
		else {
			if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.ORDERS.CANNOTFULFILLORDEREXCEPTION" || response.error && response.error.error == "COM.CRM.EXCEPTIONS.CANNOTFULFILLORDEREXCEPTION") {
				return createResult(ErrorCodes.CAN_NOT_FULFILL_ORDER_EXCEPTION, response.error);
			}
			return createCommonResult(response);
		}
	} catch (e) {
		console.log('Exception getMyOrders: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}


async function getProductCategories({
	parent_id,
	inclde_child_nodes,
	return_all,
	page = 1,
	size = 100,
	sort = 'name',//='UPDATED_DATE',
	order = 'ASC', //='DESC'
} = {},) {
	try {
		let response = await httpUtil.get({
			resourcePath: '/v1/product_categories',
			withAccessToken: true,
			queryParams: {
				parent_id,
				inclde_child_nodes,
				return_all,
				page,
				size,
				sort,
				order,
				available_in_order_menus: true
			}
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception get product categories: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getProducts({
	name,
	owned_by,
	fulfilled_by,
	type_id,
	category_id,
	order_catalog_id,
	order_category_id,
	brand_id,
	family_id,
	supply_method,
	account_id,
	page = 1,
	size = 100,
	sort = 'name',//='UPDATED_DATE',
	order = 'ASC', //='DESC'
} = {},) {
	try {
		let validity_date = Math.floor(new Date().getTime() / 1000.0);
		console.log("validity_date:",validity_date);
		let query = {
			name,
			owned_by,
			fulfilled_by,
			type_id,
			category_id,
			order_catalog_id,
			order_category_id,
			brand_id,
			family_id,
			supply_method,
			account_id,
			page,
			size,
			sort,
			order,
		}
		query["validity_date"] = validity_date;
		let response = await httpUtil.get({
			resourcePath: '/v1/products',
			withAccessToken: true,
			queryParams: query
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception get product categories: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getProductVariations(productID, supply_method) {
	try {
		let response = await httpUtil.get({
			resourcePath: '/v1/products/' + productID + '/variants',
			queryParams: {
				supply_method: supply_method
			},
			withAccessToken: true
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception get product categories: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}


async function getProductComponents(productID) {
	try {
		let response = await httpUtil.get({
			resourcePath: '/v1/products/' + productID + '/components',
			withAccessToken: true
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception get product categories: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}


async function estimateOrderV1({
	supply_method,
	fulfilled_by,
	requested_delivery_at,
	address_id,
	notes,
	line_items,
	use_wallet_funds,
	current_location,
	payment_method_type,
	wallet_funds_amount
}, accountId) {
	try {

		if (!accountId) {
			let primeAccRes = await account.getPrimaryAccount();
			if (primeAccRes.code != ErrorCodes.OK)
				return primeAccRes;
			if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
				return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
			accountId = primeAccRes.data.content[0].id;
		}
		let queue_id = null;
		let appConfigV2 = getPortalConfigV2();
		let orderConfig = appConfigV2?.features?.contact?.order || null;
		if (orderConfig) {
			if (supply_method == 'DELIVERY') queue_id = orderConfig?.delivery?.queue_id || null;
			else if (supply_method == 'PICK_UP') queue_id = orderConfig?.pick_up?.queue_id || null;
			else if (supply_method == 'DIRECT_SALE') queue_id = orderConfig?.direct_sale?.queue_id || null;
		}
		let response = await httpUtil.post({
			resourcePath: '/v1/estimates/orders',
			body: {
				account_id: accountId,
				supply_method,
				fulfilled_by,
				requested_delivery_at,
				address_id,
				notes,
				line_items,
				use_wallet_funds,
				current_location,
				payment_method_type,
				wallet_funds_amount,
				queue_id: queue_id,
			},
			withAccessToken: true
		});
		//check return code here instead of put as there would be different intepretation for different API
		//console.log('response=1=====',response)
		if (response.code == 'OK') {
			return createCommonResult(response);
		} else {
			if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.ORDERS.CANNOTFULFILLORDEREXCEPTION"
				|| response.error && response.error.error == "COM.CRM.EXCEPTIONS.CANNOTFULFILLORDEREXCEPTION" || response.error && response.error.error == "CRM.EXCEPTIONS.CANNOTFULFILLORDEREXCEPTION") {
				return createResult(ErrorCodes.CAN_NOT_FULFILL_ORDER_EXCEPTION, response.error);
			} else if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.ORDERS.MINIMUMORDERAMOUNTNOTREACHEDEXCEPTION" || response.error && response.error.error == "COM.CRM.EXCEPTIONS.MINIMUMORDERAMOUNTNOTREACHEDEXCEPTION") {
				return createResult(ErrorCodes.MINIMUM_ORDER_AMOUNT_NOT_REACHED, response.error);
			}
			else if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.SERVICEALREADYEXISTSONSUBSCRIPTIONEXCEPTION") {
				return createResult(ErrorCodes.SERVICE_ALREADY_EXIST, response.error);
			}
			else if (response.error && response.error.error == "FINANCE.EXCEPTIONS.CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION") {
				return createResult(ErrorCodes.CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION, response.error);
			}
			else if (response.error && response.error.error == "CRM.EXCEPTIONS.CANNOTSPENDAMOUNTWALLETBALANCENOTENOUGHEXCEPTION") {
				return createResult(ErrorCodes.CANNOTSPENDAMOUNTWALLETBALANCENOTENOUGHEXCEPTION, response.error);
			}else if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.CANNOTEXECUTESUBSCRIPTIONACTIONEXCEPTION") {
				return createResult(ErrorCodes.CANNOTEXECUTESUBSCRIPTIONACTIONEXCEPTION, response.error);
			}
			return createCommonResult(response);
		}
	} catch (e) {
		console.log('Exception estimateOrder: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function estimateOrder({
    account_id,
    supply_method,
    fulfilled_by,
    requested_delivery_at,
    address_id,
    notes,
    queue_id,
    use_wallet_funds,
    wallet_funds_amount,
    payment_method_type,
    discount,
    milestones,
    line_items,
    current_location,
    estimation_id
} = {}) {
    try {
        if (!account_id) {
            let primeAccRes = await account.getPrimaryAccount();
            if (primeAccRes.code != ErrorCodes.OK)
                return primeAccRes;
            if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
                return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
            account_id = primeAccRes.data.content[0].id;
        }
		let queue_id = null;
		let appConfigV2 = getPortalConfigV2();
		let orderConfig = appConfigV2?.features?.contact?.order || null;
		if (orderConfig) {
			if (supply_method == 'DELIVERY') queue_id = orderConfig?.delivery?.queue_id || null;
			else if (supply_method == 'PICK_UP') queue_id = orderConfig?.pick_up?.queue_id || null;
			else if (supply_method == 'DIRECT_SALE') queue_id = orderConfig?.direct_sale?.queue_id || null;
		}
        let response = await httpUtil.post({
            resourcePath: '/v2/estimates/orders',
            body: {
                account_id,
                supply_method,
                fulfilled_by,
                requested_delivery_at,
                address_id,
                notes,
                queue_id,
                use_wallet_funds,
                wallet_funds_amount,
                payment_method_type,
                discount,
                milestones,
                items: line_items,
                current_location,
                estimation_id
            },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        //console.log('response=1=====',response)
        if (response.code == 'OK') {
            return createCommonResult(response);
        } else {
            if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.ORDERS.CANNOTFULFILLORDEREXCEPTION"
                || response.error && response.error.error == "COM.CRM.EXCEPTIONS.CANNOTFULFILLORDEREXCEPTION" || response.error && response.error.error == "CRM.EXCEPTIONS.CANNOTFULFILLORDEREXCEPTION") {
                return createResult(ErrorCodes.CAN_NOT_FULFILL_ORDER_EXCEPTION, response.error);
            } else if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.ORDERS.MINIMUMORDERAMOUNTNOTREACHEDEXCEPTION" || response.error && response.error.error == "COM.CRM.EXCEPTIONS.MINIMUMORDERAMOUNTNOTREACHEDEXCEPTION") {
                return createResult(ErrorCodes.MINIMUM_ORDER_AMOUNT_NOT_REACHED, response.error);
            }
            else if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.SERVICEALREADYEXISTSONSUBSCRIPTIONEXCEPTION") {
                return createResult(ErrorCodes.SERVICE_ALREADY_EXIST, response.error);
            }
            else if (response.error && response.error.error == "FINANCE.EXCEPTIONS.CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION") {
                return createResult(ErrorCodes.CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION, response.error);
            }
            else if (response.error && response.error.error == "CRM.EXCEPTIONS.CANNOTSPENDAMOUNTWALLETBALANCENOTENOUGHEXCEPTION") {
                return createResult(ErrorCodes.CANNOTSPENDAMOUNTWALLETBALANCENOTENOUGHEXCEPTION, response.error);
            } else if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.CANNOTEXECUTESUBSCRIPTIONACTIONEXCEPTION") {
                return createResult(ErrorCodes.CANNOTEXECUTESUBSCRIPTIONACTIONEXCEPTION, response.error);
            }
            return createCommonResult(response);
        }
    } catch (e) {
        console.log('Exception estimateOrder: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}


async function orderProvisioning({
	supply_method,
	postal_code,
	lat_lot,
	address_id,
	requested_delivery_at,
	is_open
}) {
	try {
		let response = await httpUtil.post({
			resourcePath: '/v1/estimates/order_provisioning',
			body: {
				supply_method,
				postal_code,
				lat_lot,
				address_id,
				requested_delivery_at,
				is_open
			},
			withAccessToken: true
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception orderProvisioning: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function orderFulfillment({
	supply_method,
	postal_code,
	lat_lot,
	address_id,
	requested_delivery_at,
	requested_organisation_id,
	is_open=true
}) {
	try {
		let response = await httpUtil.post({
			resourcePath: '/v1/estimates/order_fulfillment',
			body: {
				supply_method,
				postal_code,
				lat_lot,
				address_id,
				requested_delivery_at,
				requested_organisation_id,
				is_open
			},
			withAccessToken: true
		});
		//check return code here instead of put as there would be different intepretation for different API
		if (response.code == 'OK') {
			return createCommonResult(response);
		} else {
			if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.ORDERS.CANNOTFULFILLORDEREXCEPTION"
				|| response.error && response.error.error == "COM.CRM.EXCEPTIONS.CANNOTFULFILLORDEREXCEPTION" || response.error && response.error.error == "CRM.EXCEPTIONS.CANNOTFULFILLORDEREXCEPTION") {
				return createResult(ErrorCodes.CAN_NOT_FULFILL_ORDER_EXCEPTION, response.error);
			}
			return createCommonResult(response);
		}
	} catch (e) {
		console.log('Exception orderFulfillment: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function makeOrder({
	estimation_id,
	payments,
	use_wallet_funds,
	wallet_funds_amount,
}) {
	try {
		let response = await httpUtil.post({
			resourcePath: '/v1/orders',
			body: {
				estimation_id,
				payments,
				use_wallet_funds,
				wallet_funds_amount,
			},
			withAccessToken: true
		});
		if (response.code == 'OK') {
			return createCommonResult(response);
		} else {
			if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.ORDERS.CANNOTFULFILLORDEREXCEPTION"
				|| response.error && response.error.error == "COM.CRM.EXCEPTIONS.CANNOTFULFILLORDEREXCEPTION" || response.error && response.error.error == "CRM.EXCEPTIONS.CANNOTFULFILLORDEREXCEPTION") {
				return createResult(ErrorCodes.CAN_NOT_FULFILL_ORDER_EXCEPTION, response.error);
			} else if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.ORDERS.MINIMUMORDERAMOUNTNOTREACHEDEXCEPTION" || response.error && response.error.error == "COM.CRM.EXCEPTIONS.MINIMUMORDERAMOUNTNOTREACHEDEXCEPTION") {
				return createResult(ErrorCodes.MINIMUM_ORDER_AMOUNT_NOT_REACHED, response.error);
			}
			else if (response.error && response.error.error == "FINANCE.EXCEPTIONS.CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION") {
				return createResult(ErrorCodes.CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION, response.error);
			}
			return createCommonResult(response);
		}
	} catch (e) {
		console.log('Exception addDevice: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getProductDetail(productID) {
	try {
		let response = await httpUtil.get({
			resourcePath: '/v1/products/' + productID,
			queryParams: {},
			withAccessToken: true
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception get product categories: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}
async function getOrderCatalogs({
	search_value,
	fulfilled_by,
	supply_method,
	ordering_time,
	page = 1,
	size = 100,
	sort = 'name',//='UPDATED_DATE',
	order = 'ASC', //='DESC'
} = {},) {
	try {
		if(!fulfilled_by){
			fulfilled_by = httpUtil.getSession().current_organisation_id;
		}
		let response = await httpUtil.get({
			resourcePath: '/v1/order_catalogs',
			withAccessToken: true,
			queryParams: {
				search_value,
				fulfilled_by,
				supply_method,
				ordering_time,
				page,
				size,
				sort,
				order,
			}
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception get order catalog: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getOrderCategories({
	search_value,
	parent_id,
	return_all,
	page = 1,
	size = 100,
	sort = 'priority',//='UPDATED_DATE',
	order = 'ASC', //='DESC'
} = {}, catalogId) {
	try {
		let response = await httpUtil.get({
			resourcePath: '/v1/order_catalogs/' + catalogId + '/categories',
			withAccessToken: true,
			queryParams: {
				search_value,
				parent_id,
				return_all,
				page,
				size,
				sort,
				order,
			}
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception get order categories: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function createPaymentForm({
	estimation_id,
	payment_method_id,
	redirect_url
}) {
	try {
		let response = await httpUtil.get({
			resourcePath: '/v1/jcc/payment_form',
			withAccessToken: true,
			queryParams: {
				estimation_id,
				payment_method_id,
				redirect_url
			},
			returnText: true
		});
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception addDevice: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getPriceTerms(productID) {
	try {
		let response = await httpUtil.get({
			resourcePath: '/v1/products/' + productID + '/prices',
			withAccessToken: true
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception get product categories: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}

async function getQueues(){
	try {
		let response = await httpUtil.get({
			resourcePath: '/v1/queues',
			withAccessToken: true,
		});
		//check return code here instead of put as there would be different intepretation for different API
		return createCommonResult(response);
	} catch (e) {
		console.log('Exception get queues: ', e);
		return createResult(ErrorCodes.UNKNOWN, e);
	}
}